import React, { Component } from "react";
import axios from "../../axios";
import Alert from "react-s-alert";
import FormDropdown from "../../components/FormDropdown";
import XLSX from 'xlsx'
import Dropzone from 'react-dropzone'
import DataImportGagalModal from '../../components/DataImportGagalModal'
import { status_import } from '../../constants/general'
import qs from 'qs'


class ImportSiswa extends Component {
    constructor(props) {
        super(props);

        this.state = {
            kelas_id: "",
            kelas_nama: "",
            file: [],
            message:"",
            status_import:"",
            dataKelas : [],
            dataGagal :[],
            isButtonLoading: false,
            isLoading: false,
            isModalVerifikasi  : false
        };

        this.handleChange = this.handleChange.bind(this);
        this.exportFile = this.exportFile.bind(this);
        this.exportFileRFID = this.exportFileRFID.bind(this);
		this.toggleModalVerifikasi  = this.toggleModalVerifikasi.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    toggleModalVerifikasi() {
        this.setState({ isModalVerifikasi: !this.state.isModalVerifikasi})
        
        console.log(this.state.dataGagal)
	}

    loadDataKelas() {

        axios.post("/kelas")
            .then(response => {
                return response.data.data.map(item => ({
                    key: item.kelas_id,
                    value: item.kelas_nama
                }))
            })
            .then(result => {
                this.setState({
                    dataKelas: result,
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    handleChange(event) {

        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        })

        if(name === 'kelas_id'){
            let result = this.state.dataKelas.filter(t=>t.key == target.value);
            this.setState({
                kelas_nama : result[0].value
            })
        }
    }


    exportFile() {
        if (this.state.kelas_id === '') {
            Alert.error("Kelas wajib dipilih!");return false;
        }

        let op = ["siswa_nisn","siswa_nama","siswa_username","siswa_password","kelas_nama"];
        for (var i = 1; i <= this.state.option_count; i++) {
            op.push(i);
        }

        let single = [op]

        single.push(["","","","",this.state.kelas_nama])
        const wb = XLSX.utils.book_new()
        const wsAll = XLSX.utils.aoa_to_sheet(single)
        XLSX.utils.book_append_sheet(wb, wsAll, "kelas")
        XLSX.writeFile(wb, "Format Import Data Siswa "+".xlsx");

    }

    exportFileRFID() {

        if (this.state.kelas_id === '') {
            Alert.error("Kelas wajib dipilih!");return false;
        }

        this.setState({ isLoading: true })

        const params = qs.stringify({
            kelas: this.state.kelas_id
        })
                       
        axios.post("/getdataimportrfid?" + params)
            .then(response => {

                const result = response.data
                this.setState({
                    dataUsers  : result.data.data,
                    pageCount  : result.data.last_page,
                    totaldata   : result.data.total,
                    isLoading  : false
                })

                let op = [["No","siswa_id","user_nama","siswa_nisn","kelas_nama","user_status","siswa_rfid"]]

                result.data.map((item,i) => {
                    op.push([
                        i+1,
                        item.siswa_id,
                        item.user_nama,
                        item.siswa_nisn,  
                        item.kelas_nama, 
                        item.user_status === "1" ? "Aktif" : "Non Aktif", 
                        item.siswa_rfid
                    ])
                })

                const wb = XLSX.utils.book_new()
                const wsAll = XLSX.utils.aoa_to_sheet(op)
                XLSX.utils.book_append_sheet(wb, wsAll, "kelas")
                XLSX.writeFile(wb, "Format Import RFID Siswa "+".xlsx");

            })
            .catch((error) => {
                
                console.log(error)

                this.setState({ isLoading: false })

                Alert.error("Gagal terhubung ke server!")
            })


        

    }

    loadDataMapel(){
        axios.post("/mapel")
            .then(response => {
                return response.data.data.map(item => ({
                    key: item.mapel_id,
                    value : item.mapel_nama
                }))
            })
            .then(result => {
                this.setState({
                    dataMapel: result
                })
            })
            .catch(error => {
                console.log("Mapel Undefinded")
            })
    }

    handleDeleteFile(index) {

        const copiedStateFiles = [
            ...this.state.file
        ]

        copiedStateFiles.splice(index, 1)

        this.setState({
            file: copiedStateFiles
        })
    }

    onDrop(files) {
        const newState = this.state.file.concat(files)
        this.setState({
            file: newState
        });
    }

    handleSubmit() {
        let formData = new FormData();
        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }

        if ([]) {
            formData.append('file', this.state.file[0])
        }else{
            formData.append('file', '')
        }

        if (this.state.status_import == 1) {
            formData.append('status_import', 'import_data')
        }else{
            formData.append('status_import', 'import_rfid')
        }

        formData.append('kelas_id', this.state.kelas_id)
        formData.append("user_id", localStorage.SISMART_USER_ID)

        const url = "data/import"

        this.setState({ isButtonLoading: true })

        axios.post(url, formData, config)
            .then(response => {
                const result = response.data;

                if (result.success) {
                    Alert.success(result.message)
                    this.props.history.replace("/users?l=siswa")
                }
                else {
                    if (Array.isArray(result.message)) {

						result.message.map(item => {
							Alert.info(item)

							return true
						})
					}
					else {
                        
                        if(result.data.length > 0){
                            this.setState({
                                dataGagal  : result.data,
                                message  : result.message,
                                isLoading  : false
                            },()=>{
                                this. toggleModalVerifikasi();
                            })
                            Alert.info(result.message)
                        }else{
                            this.setState({
                                dataGagal  : result.data,
                                message  : result.message,
                                isLoading  : false
                            },()=>{
                                this. toggleModalVerifikasi();
                            })
                            Alert.info(result.message)
                        }
					}
                    this.setState({ isButtonLoading: false })
                }
            })

            .catch(error => {
                Alert.error("Gagal terhubung ke server!")
                this.setState({ isButtonLoading: false })
            })
    }

    componentDidMount() {
        this.loadDataKelas()

    }

    render() {
        return (
            <div className="col-sm-12">

                <DataImportGagalModal
                    isShow={this.state.isModalVerifikasi}
                    toggleModalVerifikasi={this.toggleModalVerifikasi}
                    modalHeaderText="Data Gagal Import"
                    modalBodyText={this.state.message}
                    dataGagal = {this.state.dataGagal ? this.state.dataGagal : []}
                    status_import = {this.state.status_import}
                    modalSubmitText="Ya" />

                <div className="card" >
                    <div className="card-header">{this.props.mode} Form Import Data Siswa</div>
                    <div className="card-block">
                        {this.state.isLoading ? (
                            "Memuat Data..."
                        ) : (
                            <div className="form-horizontal animated fadeIn">
                                <div className="form-group row">
                                    <div className="col-md-12">

                                        <div className="form-group row">
                                            <label className="col-md-2 form-control-label">
                                                Import
                                            </label>
                                            <div className="col-md-4">
                                                <FormDropdown
                                                    items={status_import}
                                                    onChange={this.handleChange}
                                                    value={this.state.status_import}
                                                    name="status_import"
                                                />
                                            </div>
                                        </div>
                                        
                                        <div className="form-group row">
                                            <label className="col-md-2 form-control-label">
                                                Kelas
                                            </label>
                                            <div className="col-md-4">
                                                <FormDropdown
                                                    items={this.state.dataKelas}
                                                    onChange={this.handleChange}
                                                    value={this.state.kelas_id}
                                                    name="kelas_id"
                                                />
                                            </div>
                                        </div>

                                        {this.state.status_import == '1' ?
                                            <div>
                                                <div className="col-md-6">
                                                    <button
                                                        className="btn btn-primary pull-right"
                                                        disabled={this.state.isButtonLoading && "disabled"}
                                                        onClick={this.exportFile}>
                                                        {this.state.isButtonLoading ? "Loading" : "Generate Excel Format"}
                                                    </button>{" "}

                                                </div>

                                                <label className="col-md-12 form-control-label">
                                                    <strong>*Tentukan data kelas apa yg anda ingin import, Lalu generate excel format</strong><br/>
                                                    <strong>*Pastikan file sesuai formatnya seperti yg anda generate</strong><br/>
                                                </label>
                                                <div className="form-group row">
                                                    <label className="col-md-12 form-control-label">File Import</label>
                                                    <div className="col-md-12">

                                                        <Dropzone
                                                            onDrop={this.onDrop.bind(this)}
                                                            style={{
                                                                width: "100%",
                                                                height: "auto",
                                                                border: "2px dashed #e9e9e9",
                                                                padding: "20px 30px",
                                                                color: "#888",
                                                                cursor: "pointer",
                                                                textAlign: "center",
                                                                marginBottom: "15px"
                                                            }}
                                                        >
                                                            Klik atau drop file disini untuk mengupload file
                                                        </Dropzone>

                                                        <ul>
                                                            {
                                                                this.state.file.map((item, index) =>
                                                                    <li key={"file" + index} style={{ marginBottom: "10px" }}>
                                                                        {item.name} {" "}
                                                                        <button
                                                                            title="Hapus"
                                                                            className="btn btn-sm btn-danger"
                                                                            onClick={() => this.handleDeleteFile(index)}
                                                                            type="button"
                                                                        >
                                                                            <i className="fa fa-remove"></i>
                                                                        </button>
                                                                    </li>
                                                                )
                                                            }
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        :""}
                                        {this.state.status_import == '0' ?
                                            <div>
                                                <div className="col-md-6">
                                                    <button
                                                        className="btn btn-primary pull-right"
                                                        disabled={this.state.isButtonLoading && "disabled"}
                                                        onClick={this.exportFileRFID}>
                                                        {this.state.isButtonLoading ? "Loading" : "Generate Excel Format"}
                                                    </button>{" "}

                                                </div>

                                                <label className="col-md-12 form-control-label">
                                                    <strong>*Generate excel format untuk import RFID</strong><br/>
                                                    <strong>*Isi Data RFID siswa di kolom RFID</strong><br/>
                                                    <strong>*Pastikan file sesuai formatnya seperti yg anda generate</strong><br/>
                                                </label>
                                                <div className="form-group row">
                                                    <label className="col-md-12 form-control-label">File Import</label>
                                                    <div className="col-md-12">

                                                        <Dropzone
                                                            onDrop={this.onDrop.bind(this)}
                                                            style={{
                                                                width: "100%",
                                                                height: "auto",
                                                                border: "2px dashed #e9e9e9",
                                                                padding: "20px 30px",
                                                                color: "#888",
                                                                cursor: "pointer",
                                                                textAlign: "center",
                                                                marginBottom: "15px"
                                                            }}
                                                        >
                                                            Klik atau drop file disini untuk mengupload file
                                                        </Dropzone>

                                                        <ul>
                                                            {
                                                                this.state.file.map((item, index) =>
                                                                    <li key={"file" + index} style={{ marginBottom: "10px" }}>
                                                                        {item.name} {" "}
                                                                        <button
                                                                            title="Hapus"
                                                                            className="btn btn-sm btn-danger"
                                                                            onClick={() => this.handleDeleteFile(index)}
                                                                            type="button"
                                                                        >
                                                                            <i className="fa fa-remove"></i>
                                                                        </button>
                                                                    </li>
                                                                )
                                                            }
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        :""}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="card-footer">


                        <button
                            type="button"
                            className="btn btn-md btn-primary"
                            disabled={this.state.isButtonLoading && "disabled"}
                            onClick={this.handleSubmit}
                        >
                            {this.state.isButtonLoading ? "Loading" : "Import"}
                        </button>{" "}
                        <button
                            type="button"
                            className="btn btn-md btn-danger"
                            disabled={this.state.isButtonLoading && "disabled"}
                            onClick={() => this.props.history.goBack()}
                        >
                            Batal
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default ImportSiswa;



// WEBPACK FOOTER //
// ./src/views/Users/ImportSiswa.js